 <template>
  <div id="task">
   
    <!-- Simple header with fixed tabs. -->
    
       
        <v-app-bar width="100%"   color="primary " class="white--text pl-5 pr-5"  > 
          <!-- Title -->
          <v-toolbar-title class="headline" style="letter-spacing: 3px!important;">
            {{this.date.getFullYear()}}-{{this.date.getMonth() + 1 }}-{{this.date.getDate()}}({{this.days[this.date.getDay()]}})
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click.stop="dialog = true" color="white" class="display-1">mdi-account-details</v-icon>
           
            
            <v-dialog
      v-model="dialog"
      max-width="290"
      
       
    >
      <v-card>
        <v-card-title class="headline text-center "  >
           ユーザー情報
        </v-card-title>
 
       <v-card-text class="black--text text-center title mt-2">{{username}}</v-card-text>
       <div  style="position: relative;width: 120px; margin: 0 auto;"> 
       <v-img class="mb-3 " width="120px" style="border-radius: 60px; margin: 0 auto;"  :src="photoUrl" alt="プロフィール画像"></v-img>
       <div   style="bottom: -25px;right: -10px;position: absolute;z-index: 999999;background-color: #ddd;border-radius: 50px;"> 
       <v-icon color="primary" class="headline pa-3"  v-if="photoUrl!== null">mdi-camera</v-icon>
       </div>
        </div>
       <v-card-text><span>メールアドレス</span><br>{{strB + emailStr}}</v-card-text>
        
       <v-card-text><span>ユーザー番号</span><br>{{uid}}</v-card-text>
        
       <v-btn style="width: 240px;margin: 0 auto;display: block;"   @click="logOut">ログアウト</v-btn>
      
      
      </v-card>
    </v-dialog>
         
          
        </v-app-bar>

        
        
        <!-- New task -->
        <v-container class="mb-16"  width="100%" style="max-width: 960px; margin: 0 auto ; ">
        <div class="task-create d-flex justify-space-between " style="align-items: center;"  >
            <div class="input-outer" style="width: 90%;position: relative;"> 
            <v-text-field outlined label="＋ タスクを追加する" @focus="focusActive()"  style="border-radius: 5px; width: 100%;outline: none;display: block!important;" class="mt-7" type="text" v-model="newTodoName"></v-text-field>
            <transition mode="out-in">
             <button   type="submit" @click="createTodo(),focusUnactive()" class=" plus-icon"  v-show="onFocus">
             <v-icon width="100%" class="display-2 blue--text "  >mdi-plus-box</v-icon>
             </button>
            </transition>
            </div>
         
           
          <v-icon @click="removeAllTodo()" class="pa-2 display-2">mdi-trash-can-outline</v-icon>
        </div>

        <!-- Tabs -->
         <div class="d-flex justify-center  mt-2 tab">
          <a href="#fixed-tab-1"  v-bind:class="{'is-active': selectedAll}" v-on:click="selectDisplay('all')">All</a>
          <a href="#fixed-tab-2"   v-bind:class="{'is-active': selectedActive}" v-on:click="selectDisplay('active')">Active</a>
          <a href="#fixed-tab-3"   v-bind:class="{'is-active': selectedComplete}" v-on:click="selectDisplay('complete')">Complete</a>
        </div>

       

        <!-- todo 一覧表示 -->
         
          <div v-if="todos==null" class="baseline pt-16 pb-16 " style="text-align: center;color: #888;"><v-img src="../assets/lazy.png" width="160px" style="display: block;margin: 0 auto;"></v-img><p>現在、タスクはありません<br>気が向いたら追加しましょう</p></div>
          <v-list class="pa-5 body-1" style="list-style: none; border-bottom: 1px solid #ddd;" v-for="(todo, key) in filterdTodos" :key="todo.id">
              
            <v-list-item-group>
             <v-list>
              <a href="#"  v-if="todo.isComplete==true" v-on:click="updateIsCompleteTodo(todo, key)"><v-icon class="display-1 primary--text">mdi-checkbox-marked-outline</v-icon></a>
              <a href="#"  v-if="todo.isComplete==false" v-on:click="updateIsCompleteTodo(todo, key)"><v-icon class="display-1 primary--text ">mdi-checkbox-blank-outline</v-icon></a>
              <span class="pl-5">{{todo.name}}</span>
              <button style="float: right;" @click="removeTodo(key)" v-if="todo.isComplete==true"><v-icon class="display-1">mdi-close-thick</v-icon></button>
             </v-list>
            </v-list-item-group>
            </v-list>  
          
         

     
      </v-container>
       <v-footer padless fixed bottom class="primary white--text">
    <v-col
      class="text-center"
      cols="12"
    >
      <strong class="title">TooDo</strong>
    </v-col>
  </v-footer>
    </div>

  
</template>

<style>
.large {
  font-size: 2em;
}
.checked {
  color: rgb(255,64,129);
}
.is-active {
  color: #ffffff!important;
  background: rgb(255,64,129);
}
a {
  text-decoration: none!important;
}
</style>

<script>
import firebase from "firebase";
import router from '../router'
export default {
  name: "Task",
  
  data() {
    
    return {
      username: firebase.auth().currentUser.displayName,
      uid: firebase.auth().currentUser.uid,
      photoUrl: firebase.auth().currentUser.photoURL,
      emailVerified: firebase.auth().currentUser.emailVerified,
      database: null,
      todosRef: null,
      todos: [],
      showTodoType: "all",
      selectedAll : true,
      selectedActive: false,
      selectedComplete: false,
      newTodoName: '',
      date: new Date(),
      days: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
      btnShow: false,
      onFocus: false,
      emailStr: firebase.auth().currentUser.email.slice(2),
      strB: '**',
      dialog: false,
       
       
         
    };
  },
  
  created: function () {
     
      //リロードしたときやウィンドウを閉じるときにに確認メッセージを出す
      window.addEventListener("beforeunload", (event) =>{
          event.returnValue = '';
      });
     
    this.database = firebase.database();
    this.uid = firebase.auth().currentUser.uid;
    this.todosRef = this.database.ref("todos/" + this.uid); // '/todos/<uid>/*' 以下を参照する。
    // データに変更があるときに実行される
    var _this = this;
    this.todosRef.on("value", (snapshot) => {
      _this.todos = snapshot.val(); // 再取得して todosに格納する。
    });
  },
  computed: {
    // フィルター実装。showTodoType が変更されると実行される
    filterdTodos: function() {
      if (this.showTodoType == "complete") {
        var complete_list = {};
        for (var key_c in this.todos){
          var todo_c = this.todos[key_c];
          if (todo_c.isComplete == true) {
            complete_list[key_c] = todo_c;
          }
        }
        return complete_list;
      } else if (this.showTodoType == "active") {
        var active_list = {};
        for (var key_a in this.todos){
          var todo_a = this.todos[key_a];
          if (todo_a.isComplete == false) {
            active_list[key_a] = todo_a;
          }
        }
        return active_list;
      }
      return this.todos;
    },
  },
  methods: {
    
       
    createTodo: function() {
      if (this.newTodoName == ""){
        alert('空欄です');
        return;
         
      }
      this.todosRef.push({
        name: this.newTodoName,
        isComplete: false
      });
      this.newTodoName = "";
    },
    // 完了・未完了の値の更新
    updateIsCompleteTodo: function(todo, key) {
      if (todo.isComplete == true) {
        todo.isComplete = false;
      } else {
        todo.isComplete = true;
      }
      var updates = {};
      updates[key] = todo;
      this.todosRef.update(updates);
    },
    selectDisplay: function(kind) {
      if (kind == 'all'){
        this.showTodoType = 'all';
        this.selectedAll = true;
        this.selectedActive = false;
        this.selectedComplete = false;
      } else if (kind == 'active'){
        this.showTodoType = 'active';
        this.selectedAll = false;
        this.selectedActive = true;
        this.selectedComplete = false;
      } else if (kind == 'complete') {
        this.showTodoType = 'complete';
        this.selectedAll = false;
        this.selectedActive = false;
        this.selectedComplete = true;
      }
    },
    removeTodo: function(key) {
      if(!confirm('このタスクを削除してもよろしいですか?'))  {
       event.preventDefault();
       } else { 
       this.todosRef.child(key).remove();
       }
   },
    removeAllTodo: function() {
     if(!confirm('全てのタスクを削除してもよろしいですか？')) {
       event.preventDefault()
     } else if(this.todos== null) {
       alert('削除するものがありません');
      }else{ this.todosRef.remove();
     }
   },
   focusActive: function() {
     this.onFocus = true;
   },
   focusUnactive: function(){
     this.onFocus = false;
   },
    logOut: function() { 
  firebase.auth().signOut().then(()=>{
    alert('ログアウトしました。');
    router.push('/');
  })
  .catch( (error)=>{
     alert(error.message);
   
});
  },
     
   
    

   
    

   
    
  },
  
};
</script>
<style scoped>
 
.flex {
    display: flex;
    justify-content: center;
    
} 
.v-list-item {
    display: block;
    text-align: center;
}
.is-active {
   background-color: #f5f4fc;
    border: 2px dashed orange;
    color:#ee2dc7!important;
}
button {
  outline: none!important;
}

.tab a {
  width: 33.3%;
  text-align: center;
  padding: 20px 0;
  color: #333;
}
  .plus-icon {
    position: absolute;
    top: 32px;
    right: 40px;
    
  }
  

  @media (max-width: 480px) {
     .v-toolbar__content {
       padding: 0 5px!important;
     }
    .v-toolbar__title {
      font-size: 18px!important;
      
    } 
    .plus-icon {
      right: 10px;
    }
     
    }

    .v-card__title {
      text-align: center!important;
      display: block!important;
    }
    .v-card {
      padding-bottom: 20px!important;
    }
    v-input {
      padding: 0!important;
    }
 
</style>